import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import { Document } from '@maiia/model/generated/model/api-patient/api-patient';
import { Button, DialogActions, DialogContent } from '@mui/material';
import { useTranslation } from '@/src/i18n';
import { documentsActions } from '@/src/actions';

import Card from '../../RDVShareDocument/components/Card';

import Dialog from '@/components/molecules/Dialog/Dialog';
import { EndSharingType } from '@/components/templates/TlcAmc/utils';

type ShareDocumentChooseType = {
  endSharing: EndSharingType;
  shareDocument: (document: Document) => Promise<void>;
  dialogTitle: string;
};

const ShareDocumentChoose: React.FC<ShareDocumentChooseType> = ({
  endSharing,
  shareDocument,
  dialogTitle,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const documents = useSelector(state => get(state, 'documents'));
  const [displayCount, setDisplayCount] = useState(8);
  const [selectedDocument, setSelectedDocument] = useState<Document | null>(
    null,
  );

  useEffect(() => {
    dispatch(documentsActions.getList());
  }, []);

  return (
    <Dialog
      open
      onClose={() => endSharing()}
      title={dialogTitle}
      transitionDuration={{ enter: 0 }}
    >
      <DialogContent className="maiia-gallery">
        <p>{t('rdv_share_document_my_documents')}</p>
        <div className="document-list">
          {documents?.items?.slice(0, displayCount)?.map(item => (
            <Card
              document={item}
              key={item.id}
              isSelected={selectedDocument?.id === item.id}
              onClick={() => setSelectedDocument(item)}
            />
          ))}
        </div>
        {documents.total > displayCount && (
          <Button
            type="button"
            variant="text"
            color="primary"
            sx={{ paddingLeft: 0 }}
            onClick={() => setDisplayCount(Infinity)}
          >
            {t('show_more_documents')}
          </Button>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!selectedDocument?.id}
          variant="contained"
          color="primary"
          onClick={() => selectedDocument && shareDocument(selectedDocument)}
        >
          {t('rdv_share_document_share_exist_button')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShareDocumentChoose;
